import React, { useState } from "react";
import "./index1.css";
import "./App.css";
import Game from "./components/Game";
import { PopupProvider } from "./utils/PopupContext";
import Popup from "./components/Popup";
import PopupTrigger from "./utils/gameHelpers";

export default function App() {
  const [showPopUp, setShowPopUp] = useState(true);

  return (
    <>
      <PopupProvider>
        <Popup />
        <PopupTrigger />
        <Game />
      </PopupProvider>
    </>
  );
}
